<template lang="pug">
briq-multiselect(
  v-if="options"
  label="Country"
  placeholder="Country"
  track-by="Alpha2"
  :name="name"
  :options="options"
  :value="valueByCountryCode"
  @input="emitCountryCode"
  :custom-label="c => c.Name"
  maxlength="50",
  display="Name"
  :valueSetter="c => c.Alpha2"
  optional)
</template>

<script>
export default {
  name: 'BriqCountrySelect',
  props: {
    name: String,
    options: Array,
    value: String,
    hideOptionalMarker: { type: Boolean, default: false },
  },
  data() {
    return {
      countryCode: this.value,
    }
  },
  computed: {
    valueByCountryCode() {
      const country = this.options?.find(c => c.Alpha2 === this.countryCode)
      return country?.Alpha2
    },
  },
  methods: {
    emitCountryCode(code) {
      this.$emit('input', code)
    },
  },
}
</script>
